import ListItemIcon from "@mui/material/ListItemIcon/ListItemIcon.js";
import { styled } from '@mui/material/styles/index.js';
export default styled(ListItemIcon)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.mode === 'dark' ? theme.palette.primary.contrastText : ''
  };
});